<template>
  <div class="order-list">
    <el-card shadow="never">
      <div class="content">
        <div class="content-header">

 <el-form :inline="true" ref="vSearchForm" :model="query" label-width="130px">
            <el-form-item  label="订单号/合同号" prop="pay_number">
                <el-input  v-model="query.pay_number"></el-input>
            </el-form-item>
            <el-form-item  label="交易流水号" prop="transaction_id">
                <el-input  v-model="query.transaction_id"></el-input>
            </el-form-item>
            <el-form-item label="来源" prop="source">
              <el-select v-model="query.source" placeholder="请选择">
                <el-option value label="全部" />
                <el-option value="new_crm" label="CRM" />
                <el-option value="cloud_platform" label="云平台" />
                <el-option value="digital_platform" label="数字证书平台" />
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式" prop="payType">
              <el-select v-model="query.payType" placeholder="请选择">
                <el-option value label="全部" />
                <el-option value="pcalipay" label="支付宝扫码" />
                <el-option value="pcwechat" label="微信扫码" />
                <el-option value="alipay" label="支付宝聚合码" />
                <el-option value="jsapi" label="微信聚合码" />
              </el-select>
            </el-form-item>
          
 <el-form-item label="收款主体公司名称" prop="code">
              <el-select v-model="query.code" placeholder="收款主体公司名称">
                <el-option value label="全部" />
                <el-option
                  v-for="item in searchSelectOptions"
                  :key="item.id"
                  :label="item.company"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="支付完成时间" prop="createDate">
              <el-date-picker
                v-model="query.createDate"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :shortcuts="shortcuts"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">搜索</el-button>
              <el-button type="danger" @click="resetSearchForm">重置</el-button>
            </el-form-item>
          </el-form>

        </div>
        <div class="content-main">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%; "
             v-loading="loading"
          >
            <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
            <el-table-column prop="pay_format_number" label="订单号/合同号" align="center"></el-table-column>
            <el-table-column prop="pay_platform"  width="55" label="来源" align="center"></el-table-column>
            <el-table-column prop="format_order_time" label="订单创建时间" align="center"></el-table-column>
            <el-table-column prop="countfee"  width="55" label="订单金额" align="center"></el-table-column>
            <el-table-column prop="orderfee"  width="55" label="应付金额" align="center"></el-table-column>
            <el-table-column prop="fee"  width="55" label="支付金额" align="center"></el-table-column>
            <el-table-column prop="pay_type" label="支付方式" align="center"></el-table-column>
            <el-table-column prop="format_add_time" label="支付完成时间" align="center"></el-table-column>
            <el-table-column prop="transaction_id" label="交易流水号" align="center"></el-table-column>
            <el-table-column prop="code" label="收款主体公司编码" align="center"></el-table-column>
            <el-table-column prop="company" label="收款主体公司名称" align="center"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { listPayLog,selectCollection} from "../api/serviceApi";
export default {
  data() {
    return {
      query: {
        code: "",
        pageIndex: 1,
        pageSize: 10,
        createDate: "",
      source:"",
      payType:"",
      pay_number:"",
      transaction_id:""
      },
      starttime:"",
        endtime:"",
      searchSelectOptions: "",
      tableData: [],
      pageTotal: 0,
      pageTotalPro: 0,
      loading:false,
      shortcuts: [
        {
          text: "最近一周",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })()
        },
        {
          text: "最近一个月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })()
        },
        {
          text: "最近三个月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })()
        }
      ],
    };
  },
  created() {
    this.getData();
    this.getSelectCollectionData();
  },
  methods: {
    handlePageChange(val) {
       this.query.pageIndex = val;
      this.getData();
    },
    searchButton(){
       if (this.query.createDate) {
        this.starttime =Math.floor(new Date((this.query.createDate[0]).getTime() / 1000));
        this.endtime = Math.floor(new Date((this.query.createDate[1]).getTime() / 1000));
      } else {
        this.starttime = "";
        this.endtime = "";
      }
          this.getData();
      },
     resetSearchForm() {
      this.query.createDate = "";
      this.starttime = "";
      this.endtime = "";
      this.$refs["vSearchForm"].resetFields();
       this.getData();
    },
    getSelectCollectionData() {
      selectCollection().then(res => {
        if (res.code == 200) {
          this.searchSelectOptions = res.data;
        }else{
          console.log(res)
        }
      });
    },
    getData() {
      this.loading=true
      let params = "?page=" + this.query.pageIndex+"&companycode="+this.query.code+"&source="+this.query.source+"&transaction_id="+this.query.transaction_id+"&paytype="+this.query.payType+"&pay_number="+this.query.pay_number+"&starttime="+this.starttime+"&endtime="+this.endtime;
      listPayLog(params).then(res => {
        if(res.code==200){
           if(res.data.list){
             res.data.list.forEach(function(item) {
             item.code=item.orderinfo.partyB_account_code
             item.company=item.orderinfo.partyB_account_name
             item.countfee=item.orderinfo.total_transacrtion_amount
             item.orderfee=item.orderinfo.order_fee
            });
          this.tableData = res.data.list;
        this.pageTotal = res.data.total;
        this.query.pageSize = res.data.size;
        this.query.pageIndex = res.data.page;
           }else{
              this.tableData =[];
        this.pageTotal =0;
        this.query.pageSize =0;
        this.query.pageIndex = 0;
           }
        }
         this.loading=false
      });
    },
  }
};
</script>